import { styled } from "@mui/system";
import { TextValidator } from "react-material-ui-form-validator";
import { InputAdornment } from "@mui/material";
import MailIcon from "../../assets/Images/Union.svg";
import ForgotMail from "../../assets/icons/forgotMailIcon.svg";

const TextField = styled(TextValidator)(() => ({
  width: "100%",
  marginBottom: "16px",
  position: "relative",
}));

export function EmailField({
  value,
  handleChange,
  name,
  width = "80%",
  placeholder = "Enter your email",
  isDisabled = false,
  iconType = "Mail",
}) {
  return (
    <TextField
      variant="outlined"
      placeholder={placeholder}
      size="small"
      onChange={handleChange}
      name={name || "email"}
      value={value || ""}
      validators={["required", "isEmail"]}
      errorMessages={["Required field", "Email is not valid"]}
      disabled={isDisabled}
      InputProps={{
        autoComplete: "email",
        startAdornment: (
          <InputAdornment position="start">
            <img alt="emailicon" src={getFieldIcon(iconType)} />
          </InputAdornment>
        ),
        style: { color: "#1a1a1a", backgroundColor: "white" },
      }}
      type="email"
      sx={{
        mb: "12px",
        width: "100%",
        backgroundColor: "white !important",
        "& .MuiOutlinedInput-root": {
          backgroundColor: "white !important",
          "&:hover": {
            backgroundColor: "white !important",
            "& .MuiInputBase-input": {
              backgroundColor: "white !important",
              color: "#1a1a1a !important",
              WebkitTextFillColor: "#1a1a1a !important",
            },
            "& input": {
              backgroundColor: "white !important",
              color: "#1a1a1a !important",
              WebkitTextFillColor: "#1a1a1a !important",
            },
          },
          "&.Mui-focused": {
            backgroundColor: "white !important",
            "& .MuiInputBase-input": {
              backgroundColor: "white !important",
              color: "#1a1a1a !important",
              WebkitTextFillColor: "#1a1a1a !important",
            },
            "& .MuiOutlinedInput-input": {
              backgroundColor: "white !important",
              color: "#1a1a1a !important",
              WebkitTextFillColor: "#1a1a1a !important",
            },
            "& input": {
              backgroundColor: "white !important",
              color: "#1a1a1a !important",
              WebkitTextFillColor: "#1a1a1a !important",
            },
          },
        },
        "& .MuiInputBase-input": {
          backgroundColor: "white !important",
          color: "#1a1a1a !important",
          WebkitTextFillColor: "#1a1a1a !important",
          "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px white inset !important",
            WebkitTextFillColor: "#1a1a1a !important",
            backgroundColor: "white !important",
            transition: "background-color 5000s ease-in-out 0s",
          },
          "&:-webkit-autofill:hover": {
            WebkitBoxShadow: "0 0 0 1000px white inset !important",
            WebkitTextFillColor: "#1a1a1a !important",
            backgroundColor: "white !important",
          },
          "&:-webkit-autofill:focus": {
            WebkitBoxShadow: "0 0 0 1000px white inset !important",
            WebkitTextFillColor: "#1a1a1a !important",
            backgroundColor: "white !important",
          },
        },
        "& .MuiOutlinedInput-input": {
          backgroundColor: "white !important",
          color: "#1a1a1a !important",
          WebkitTextFillColor: "#1a1a1a !important",
          "&:focus": {
            backgroundColor: "white !important",
            color: "#1a1a1a !important",
            WebkitTextFillColor: "#1a1a1a !important",
          },
        },
        "& input": {
          backgroundColor: "white !important",
          color: "#1a1a1a !important",
          WebkitTextFillColor: "#1a1a1a !important",
          "&:focus": {
            backgroundColor: "white !important",
            color: "#1a1a1a !important",
            WebkitTextFillColor: "#1a1a1a !important",
          },
          "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px white inset !important",
            WebkitTextFillColor: "#1a1a1a !important",
            backgroundColor: "white !important",
            transition: "background-color 5000s ease-in-out 0s",
          },
          "&:-webkit-autofill:hover": {
            WebkitBoxShadow: "0 0 0 1000px white inset !important",
            WebkitTextFillColor: "#1a1a1a !important",
            backgroundColor: "white !important",
          },
          "&:-webkit-autofill:focus": {
            WebkitBoxShadow: "0 0 0 1000px white inset !important",
            WebkitTextFillColor: "#1a1a1a !important",
            backgroundColor: "white !important",
          },
        },
      }}
    />
  );
}

const getFieldIcon = (iconType) => {
  let icon = "";
  switch (iconType.toUpperCase()) {
    case "MAIL":
      icon = MailIcon;
      break;
    case "USER":
      icon = ForgotMail;
      break;
    default:
  }
  return icon;
};
